export default __webpack_public_path__ + "static/media/Support.aa606600.svg";